import React, {useState} from "react";
import {Modal} from "antd";
import ExpireNotifySvg from "../../asset/icon/ExpireNotify.svg";

function ExpireNotifyModal({
    isExpired,
    expiredDays,
}) {
    const [visible, setVisible] = useState(true);
    return (
        <Modal
            visible={visible}
            footer={null}
            width={700}
            onCancel={() => setVisible(false)}
            bodyStyle={{
                height: 320,
                width: 700,
                padding: 0,
            }}
        >
            <div
                style={{
                    display: "flex",
                    height: "100%",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                        width: 256,
                        backgroundImage: "linear-gradient(135deg, #149EFE 0%, #235FF5 100%)",
                    }}
                >
                    <ExpireNotifySvg />
                </div>
                <div
                    style={{
                        flex: "auto",
                        backgroundColor: "white",
                        padding: "24px 36px",
                        
                    }}
                >
                    <div style={{fontSize: 24, textAlign: "center", marginBottom: 20}}>
                        系统到期提醒
                    </div>
                    <div style={{color: isExpired ? "#F85853" : "#485D69", marginBottom: 10}}>
                        {
                            isExpired
                                ? `您使用的人员管理系统已到期${expiredDays}天。`
                                : `您使用的人员管理系统还有${expiredDays}天到期。`
                        }
                    </div>
                    <div style={{wordBreak: "break-all", marginBottom: 10}}>
                        请联系系统管理员在到期前完成续费，以避免服务中断。如有任何问题可拨打客服电话4008502660，我们的客服人员将竭诚为您提供支持！
                    </div>
                    <div style={{textAlign: "right"}}>
                        连帆科技智护云团队
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default ExpireNotifyModal;
